import { render, staticRenderFns } from "./ProductTitleStandard.vue?vue&type=template&id=91eb7192"
import script from "./ProductTitleStandard.vue?vue&type=script&lang=js"
export * from "./ProductTitleStandard.vue?vue&type=script&lang=js"
import style0 from "./ProductTitleStandard.vue?vue&type=style&index=0&id=91eb7192&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports